import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

const openApi = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL
});

// Interceptor to automatically prepend /api to all relative URLs without duplicating it
const addApiPrefix = (config) => {
	if (config.url) {
		if (config.url.startsWith("http") || config.url.startsWith("/api") || config.url.startsWith("api/")) {
			return config;
		}
		if (config.url.startsWith("/")) {
			config.url = `/api${config.url}`;
		} else {
			config.url = `/api/${config.url}`;
		}
	}
	return config;
};

api.interceptors.request.use(addApiPrefix);
openApi.interceptors.request.use(addApiPrefix);

export { openApi };
export default api;
